export default [
    [
        {
            name: "FRASER",
            tools: ["Face-API.js", "Chakra-UI", "React Router", "MongoDB", "Express", "React", "Node.js"],
            desc1: "Multi-factor authentication process enabling businesses to protect sensitive information by using facial recognition",
            desc2: "Tackles the issue of rising cybercrime and ransomware attacks (up 3000% since 2020) by utilizing facial data which is unique to each indiviual",
            desc3: ""
        }
    ],
    [
        {
            name: "Beacon",
            tools: ["Figma", "Mapbox API", "Firebase Auth", "MongoDB", "Express", "React", "Node.js"],
            desc1: "Crowdsourced store data platform to assist in safety measures amidst the COVID-19 outbreak.",
            desc2: "Tested at 50 grocery stores in the GTA area to facilitate purchase of essential items and limit large gatherings amidst the pandemic.",
            desc3: "Implemented geolocation technology to find nearest points of interest for customers."

        }
    ],
    [
        {
            name: "Universal",
            tools: ["Dribbble", "Bootstrap", "Cloud Functions", "HTML", "CSS", "JavaScript", "Dribbble"],
            desc1: "Contact-free personal data transfer platform enabling users to share information efficiently.",
            desc2: "Diminishes the presence of excessive, tedious, and unnecessary forms of physical contact.",
            desc3: "Recipient of the People’s Choice Award at Enactus Hacks 2020 & 2nd Overall at Hacks & Crafts 2020."
        }
    ]
];